import React from "react";
import { Layout } from "antd";

export function AppFooter() {
    return (
        <Layout.Footer style={{ textAlign: "center" }}>
            <a target="_blank" rel="noopener noreferrer" href="http://qualimaking.com/" style={{ color: "#00AEEF" }}>
                QualityMaking
            </a>
            &nbsp;
            <span style={{ color: "#201d1d" }}>© {new Date().getFullYear()} improvement and maintenance</span>
        </Layout.Footer>
    );
}
